const AddOnSelectionsForm = {
  initialize() {
    this.watchQuantityBoxes()
    this.initialCheckedChecked()
    this.watchDropDowns()
    this.watchWellCheckboxes()
    return this.toggleWellCheckboxes()
  },

  initialCheckedChecked() {
    return $('input[checked="checked"]').prop("checked", true)
  },

  watchDropDowns() {
    $(".dropdown-js").each((index, element) => {
      return this.triggerRedisplay(element)
    })
    return $(".dropdown-js").on("change", event => {
      return this.triggerRedisplay(event.target)
    })
  },

  triggerRedisplay(target) {
    const $target = $(target)
    const selection = $target.find(":selected").val()
    $target
      .closest(".variations-js")
      .find(".variation-checkbox-js")
      .prop("checked", false)
    $target
      .closest(".variations-js")
      .find(`.checkbox-${selection}-js`)
      .prop("checked", true)
    $target
      .closest(".add-on-well-js")
      .find(".well-checkbox-js")
      .prop("checked", !!selection)
    return this.showLineWithCheckedHiddenCheckbox()
  },

  watchWellCheckboxes() {
    return $(".well-check-js .well-checkbox-js").on("change", e => {
      const $addOnWell = $(e.target).closest(".add-on-well-js")
      if ($(e.target).is(":checked")) {
        const selected = $addOnWell.find("select :selected").val()
        $addOnWell.find(`.checkbox-${selected}-js`).prop("checked", true)
        $addOnWell.find(".variation-select").removeClass("hide")
        $addOnWell.find(".variations select").removeClass("hide")
        $addOnWell.find(".without-variations .multiples").removeClass("hide")
      } else {
        $addOnWell.find(".variation-checkbox-js").prop("checked", false)
        $addOnWell.find(".variations select").addClass("hide")
        $addOnWell.find(".variation-select").addClass("hide")
        $addOnWell.find(".without-variations .multiples").addClass("hide")
        $addOnWell.find(".selection-details-js").addClass("hide")
        this.changeNearestCheckBox(e.target, false)
      }
      return this.showLineWithCheckedHiddenCheckbox()
    })
  },

  toggleWellCheckboxes() {
    $(".variations").each(function(n, variation) {
      const $addOnWell = $(this).closest(".add-on-well-js")
      const checked = $(variation).find(".variation-checkbox-js:checked").length > 0
      $addOnWell.find(".well-checkbox-js").prop("checked", checked)
      if (checked) {
        $addOnWell.find(".variations-js select").removeClass("hide")
      } else {
        $addOnWell.find(".variations-js select").addClass("hide")
      }
      if (!checked) {
        return $addOnWell.find("select").val("")
      }
    })
    return $(".without-variations").each(function() {
      const $addOnWell = $(this).closest(".add-on-well-js")
      const checked = $addOnWell.find(".well-checkbox-js:checked").length > 0
      if (checked) {
        $addOnWell.find(".without-variations .multiples").removeClass("hide")
      } else {
        $addOnWell.find(".without-variations .multiples").addClass("hide")
      }
      if (!checked) {
        return $addOnWell.find("select").val("")
      }
    })
  },

  showLineWithCheckedHiddenCheckbox() {
    $("input.variation-checkbox-js")
      .closest(".selection-details-js")
      .addClass("hide")
    return $("input.variation-checkbox-js:checked")
      .closest(".selection-details-js")
      .removeClass("hide")
  },

  watchQuantityBoxes() {
    return $(".quantity-js").on("keyup", event => {
      if ($(event.target).val() === "0") {
        return this.changeNearestCheckBox(event.target, false)
      } else if ($(event.target).val() === "") {
        return this.changeNearestCheckBox(event.target, false)
      } else {
        return this.changeNearestCheckBox(event.target, true)
      }
    })
  },

  changeNearestCheckBox(inputElement, checkedState) {
    return $(inputElement)
      .parent()
      .parent()
      .find(".checkbox-js")
      .prop("checked", checkedState)
  }
}

export default AddOnSelectionsForm
